// extracted by mini-css-extract-plugin
export var bottom = "challenges-module--bottom--5f405";
export var challenges = "challenges-module--challenges--aff0d";
export var heading = "challenges-module--heading--f6a0c";
export var horizontalSpacer = "challenges-module--horizontalSpacer--d6ebe";
export var image = "challenges-module--image--2c5b8";
export var info = "challenges-module--info--1cfea";
export var left = "challenges-module--left--db0d6";
export var picture = "challenges-module--picture--684b2";
export var play = "challenges-module--play--ebffb";
export var recentChallenge = "challenges-module--recentChallenge--3a422";
export var right = "challenges-module--right--05bd8";
export var verticalSpacer = "challenges-module--verticalSpacer--1300b";